import React from "react";
import { useSelector } from "react-redux";
import { filterMap } from "../../../../helper/general";
import "./style.css";

const Filters = ({ filterData, handleFilterChange, activeFilter = [], additionalFilter = {}, additionMethod = () => { } }) => {
  const filterObj = useSelector(state => state.dashboard.filters);
  const { filters } = filterObj;
  const allFilters = { ...filters, ...additionalFilter }
  return (
    <div className="top-btn-group mb-2 d-flex">
      {Object.keys(allFilters)?.filter(item => activeFilter.indexOf(item) >= 0)?.map((filter, index) => {
        return (<div className="dropdown">
          <button className="btn-outline-bl" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
            {filter}
            {filterData?.[filterMap?.[filter]]?.length > 0 &&
              <span class="position-absolute translate-middle p-2  border border-light rounded-circle">
                <span class="numbr">{filterData?.[filterMap?.[filter]]?.length}</span>
              </span>
            }
          </button>
          <ul className="dropdown-menu check-drodrown">
            {(!!additionalFilter[filter] && filter == "Student Name") && <li><input onChange={additionMethod} className="form-control me-2" type="search" aria-label="Search" /></li>}
            {Object.keys(allFilters?.[filter])?.map((item, index) => {
              return (<li><div className="form-check py-1" key={index}>
                {filterMap?.[filter] == "meritList" ?
                  <input name={filterMap?.[filter]} onChange={handleFilterChange} value={item} checked={filterData?.[filterMap?.[filter]].indexOf(item) >= 0 ? true : false} type="checkbox" className="form-check-input" id={`${filter}-${item}`} />
                  : <input name={filterMap?.[filter]} onChange={handleFilterChange} value={item} checked={filterData?.[filterMap?.[filter]].indexOf(parseInt(item)) >= 0 ? true : false} type="checkbox" className="form-check-input" id={`${filter}-${item}`} />
                }
                <label className="form-check-label" htmlFor={`${filter}-${item}`}>{allFilters?.[filter]?.[item]}</label>
              </div></li>)
            })}
          </ul>
        </div>)
      })}
    </div>
  );
};

export default Filters;
